"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATION_SWITCHER_COPY = void 0;
exports.ORGANIZATION_SWITCHER_COPY = {
    PLACEHOLDER: 'Select Organization'
};
//# sourceMappingURL=ORGANIZATION_SWTICHER.js.map